import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components";
import { logoutUser } from "../../actions";
import { useDispatch } from "react-redux";
import "./styles.css";

function LogoutPage() {
  const navigator = useNavigate();
  const dispatch = useDispatch();

  const handleBack = () => {
    navigator(-1);
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    navigator("../register");
  };

  return (
    <>
      <div className="logoutContainer">
        <div className="logoutWrapper">
        <h1>Would You Like To Logout?</h1>
        <div>
          <Button
            onClick={handleLogout}
            text={
              <>
                Yes<span aria-hidden></span>
                <span aria-hidden class="cybrBtnGlitch">
                  Yes
                </span>
              </>
            }
          />
          <Button
            onClick={(e) => {
              handleBack(e);
            }}
            text={
              <>
                No<span aria-hidden></span>
                <span aria-hidden class="cybrBtnGlitch">
                  No
                </span>
              </>
            }
          />
          </div>
        </div>
      </div>
    </>
  );
}

export default LogoutPage;
